module.exports = __webpack_public_path__ + "media/src/application/media/route_1-82af1ba5b24b7073546892ffa489c4a4.png";